import React from "react";

interface TrainingCenterIconProps {
  isActive?: boolean;
  size?: string;
}

export const TrainingCenterIcon: React.FC<TrainingCenterIconProps> = ({
  isActive = false,
  size = "24",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 5.33333C0 2.38782 2.38781 0 5.33333 0H26.6667C29.6122 0 32 2.38781 32 5.33333V26.6667C32 29.6122 29.6122 32 26.6667 32H5.33333C2.38782 32 0 29.6122 0 26.6667V5.33333Z"
        fill={isActive ? "#01CCFF" : "transparent"}
        fillOpacity={isActive ? "0.114" : 0}
      />
      <path
        d="M9.50942 25.0236C10.0262 25.4122 10.6261 25.5998 11.2217 25.5998C12.118 25.5998 13.0025 25.1749 13.5718 24.3764C13.5734 24.3747 13.575 24.3729 13.5764 24.3711C13.5778 24.3692 13.5792 24.3673 13.5805 24.3655L13.5824 24.3625C13.5838 24.3606 13.5851 24.3586 13.5864 24.3568L15.6008 21.4882L17.6152 24.3568C17.6172 24.3599 17.6193 24.3623 17.6212 24.3649C17.6222 24.3662 17.623 24.3674 17.624 24.3688C18.5728 25.7072 20.396 26.002 21.6937 25.0251C22.9928 24.0483 23.2833 22.1596 22.3461 20.8108L22.3441 20.8074C22.3424 20.8046 22.341 20.8024 22.3388 20.8002L20.3288 17.9301L23.5855 16.8323C25.1152 16.3167 25.956 14.6064 25.4582 13.0216C24.9606 11.4369 23.311 10.5659 21.7798 11.0801L18.5232 12.1734L18.5218 8.62435C18.5202 6.95795 17.2108 5.60156 15.6023 5.60156C13.9937 5.60156 12.6843 6.95795 12.6829 8.62586L12.6799 12.1719L9.42331 11.0786C9.42202 11.0786 9.42045 11.0783 9.41887 11.0778C9.41682 11.0772 9.41472 11.0764 9.41308 11.0755C7.88476 10.5675 6.24111 11.4384 5.74481 13.0202C5.2485 14.6019 6.08347 16.3061 7.60595 16.8263C7.60736 16.8267 7.60862 16.8272 7.60983 16.8278L7.61519 16.8299L7.61764 16.8308L10.8728 17.9286L8.86276 20.7987C8.86203 20.8002 8.86095 20.8017 8.85986 20.8032C8.85875 20.8048 8.85767 20.8063 8.85694 20.8078C7.91833 22.1566 8.21028 24.0468 9.50942 25.0236Z"
        fill={isActive ? "#009DC9" : "#A1A1A1"}
        fillOpacity={isActive ? 1 : 0.5}
      />
    </svg>
  );
};
